import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../../animations/form-error';
import { BasePageComponent } from '../../../../base-page';
import { FormValidator } from '../../../../../model/champs_formulaire/form-validator.model';
import { Subject } from 'rxjs';
import { BaseService } from '../../../base/base.service';
import { ValidatorAffectedService } from '../../validator_affected/validator-affected.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormService } from '../../../../../shared/services/form.service';
import { ChampsFormulaireColumnName } from '../../champs_formulaires/champs-formulaire-column-name';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../../interfaces/app-state';
import { HttpService } from '../../../../../services/http/http.service';
import { takeUntil } from 'rxjs/operators';
import { SourceFormModel } from '../../../../../model/champs_formulaire/source-form.model';
import { SourceFormService } from '../source-form.service';
import { SourceFormColumnName } from '../source-form-column-name';

/**
 * Permet de gérer la suppression d'un country
 */
@Component({
  selector: 'app-source-form-delete',
  templateUrl: './source-form-delete.component.html',
  animations: [fadeIn]
})
export class SourceFormDeleteComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  countrySelected: SourceFormModel;
  private subs$ = new Subject<void>();
  isDeleting = false;
  successDelete = false;
  serverHasError = false;
  hasDelete = false;

  constructor(
    private baseService: BaseService,
    private formulaireService: SourceFormService,
    private dialogRef: MatDialogRef<SourceFormDeleteComponent>,
    private formService: FormService,
    private columnName: SourceFormColumnName,
    private fb: UntypedFormBuilder,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct validator delete');
  }

  ngOnInit(): void {
    console.log('## init formulaire delete.');
    this.formulaireService.getObjetSelectObs()
      .pipe(takeUntil(this.subs$)).subscribe((res) => {
      console.log('## get formulaire selected');
      try {
        console.log('## data: ', res);
        this.countrySelected = res;
      } catch (e) {
        console.log('## error get formulaire delete: ' + e.message);
      }
      super.setLoaded();
    });
  }

  ngOnDestroy() {
    console.log('## destroy formulaire delete');
    this.formService.free(this.subs$);
    this.formulaireService.setObjetSelectObs(undefined);
  }

  closeModal() {
    console.log('## close delete formulaire');
    this.dialogRef.close();
  }

  delete() {
    console.log('## deleting formulaire');
    this.isDeleting = true;
    this.serverHasError = false;
    this.successDelete = false;
    this.formulaireService.delete(this.countrySelected.id,
      this.formulaireService.resourceUrl).subscribe(
      response => {
        console.log('## success delete country');
        this.serverHasError = false;
        this.successDelete = true;
        this.isDeleting = false;
        this.hasDelete = true;
        this.responseFromServer();
        this.formulaireService.getAllObjet();
      }, error => {
        console.log('## error delete country');
        this.serverHasError = true;
        this.successDelete = false;
        this.isDeleting = false;
        this.responseFromServer();
      });
  }

  private responseFromServer() {
    setTimeout(() => {
      this.isDeleting = false;
    }, 300);
  }
}
